import { useReservationGetConflicts } from '../api/reservations'
import { ButtonLink } from '../components/button'
import { DateFormatter } from '../components/date-formatter'

export function Conflicts({ id }: { id: string }) {
	const { data: conflicts } = useReservationGetConflicts(id)
	if (!conflicts?.list.length) return null

	return (
		<div className="border border-rose-400 rounded-md bg-rose-100 p-3 my-10">
			<h3 className="font-bold">Varování</h3>
			<p className="mb-4">V tomto čase je vozidlo rezervováno nebo pronajato i jiné osobě!</p>
			<h2 className="font-semibold mb-4">Konflikty rezervací</h2>
			<div className="overflow-x-auto">
				<table className="min-w-full divide-y divide-gray-200">
					<thead>
						<tr>
							<th className="bg-rose-200 px-4 py-2 text-left text-sm font-medium text-gray-600">
								ID
							</th>
							<th className="bg-rose-200 px-4 py-2 text-left text-sm font-medium text-gray-600">
								Od
							</th>
							<th className="bg-rose-200 px-4 py-2 text-left text-sm font-medium text-gray-600">
								Do
							</th>
							<th className="bg-rose-200 px-4 py-2 text-center text-sm font-medium text-gray-600">
								Akce
							</th>
						</tr>
					</thead>
					<tbody className="divide-y divide-gray-200">
						{conflicts.list.map(conflict => (
							<tr key={conflict.id}>
								<td className="px-4 py-3 text-sm text-gray-700">{conflict.id}</td>
								<td className="px-4 py-3 text-sm text-gray-700">
									<DateFormatter date={conflict.date_from} />
								</td>
								<td className="px-4 py-3 text-sm text-gray-700">
									<DateFormatter date={conflict.date_to} />
								</td>
								<td className="px-4 py-3 text-center">
									<ButtonLink
										variant="TEXT"
										size="TEXT"
										to={`/svc/reservation/${conflict.id}`}
									>
										Detail
									</ButtonLink>
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>
		</div>
	)
}
